import React from 'react';
import { NoiseAware } from '@mui/icons-material';
import '../styles/Experience.css'

function Experience() {
  return (
    <div>

        <div className='skills-a'>
                    <div className='skillset'>
                        <h4>What Skills I Have</h4>
                        <h1>My Experience</h1>
                    </div>
                    <div className='skills'>
                        <div className='frontend'>
                            <h3>Frontend Development</h3>
                            <div className='unorderedlist'>
                                <article className='portfolio_list'>
                                    <NoiseAware />
                                    <div>
                                        <div>HTML</div>
                                        <div>Experienced</div>
                                    </div>
                                </article>
                                <article className='portfolio_list'>
                                    <NoiseAware />
                                    <div>
                                        <div>CSS</div>
                                        <div>Experienced</div>
                                    </div>
                                </article>
                                <article className='portfolio_list'>
                                        <NoiseAware />
                                    <div>
                                        <div>JavaScript</div>
                                        <div>Experienced</div>
                                    </div>
                                </article>
                                <article className='portfolio_list'>
                                <NoiseAware />
                                    <div>
                                        <div>TypeScript</div>
                                        <div>Intermediate</div>
                                    </div>
                                </article>
                                <article className='portfolio_list'>
                                <NoiseAware />
                                    <div>
                                        <div>React</div>
                                        <div>Experienced</div>
                                    </div>
                                </article>
                                <article className='portfolio_list'>
                                <NoiseAware />
                                    <div>
                                        <div>Bootstrap</div>
                                        <div>Intermediate</div>
                                    </div>
                                </article>
                            </div>
                        </div>
                        <div className='backend'>
                            <h3>Backend Development</h3>
                            <div className='unorderedlist'>
                                <article className='portfolio_list'>
                                <NoiseAware />
                                    <div>
                                        <div>Node JS</div>
                                        <div>Experienced</div>
                                    </div>
                                </article>
                                <article className='portfolio_list'>
                                <NoiseAware />
                                    <div>
                                        <div>MongoDB</div>
                                        <div>Experienced</div>
                                    </div>
                                </article>
                                <article className='portfolio_list'>
                                <NoiseAware />
                                    <div>
                                        <div>MySQL</div>
                                        <div>Experienced</div>
                                    </div>
                                </article>
                                <article className='portfolio_list'>
                                <NoiseAware />
                                    <div>
                                        <div>AWS</div>
                                        <div>Intermediate</div>
                                    </div>
                                </article>
                                <article className='portfolio_list'>
                                <NoiseAware />
                                    <div>
                                        <div>Express JS</div>
                                        <div>Intermediate</div>
                                    </div>
                                </article>
                            </div>
                        </div>
                    </div>
                </div>
    </div>
  )
}

export default Experience